import React from 'react';
import { ChevronDownIcon, ChevronLeftIcon, HomeIcon } from '@qualtrics/ui-react/icons';
import styles from './evaluationExperienceHeader.module.css';
import { IconButton, MenuItem, SelectMenu } from '@qualtrics/ui-react';
import ColoredStatus from '../../ColoredStatus/coloredStatus';
import { getCourseLabel } from '../../Util/util';
import StudentInfo from '../../StudentInfo/studentInfo';

const EvaluationExperienceHeader = ({
    evaluationPage,
    evaluations,
    setSelectedEvaluation,
    selectedEvaluation,
    brandId,
    hashedStudentId
}) => {
    const BackButton = () => {
        return (
            <IconButton
                tooltipContent="Back"
                tooltipPlacement="bottom"
                isTooltipADescription
                onClick={() => setSelectedEvaluation(undefined)}
                data-testid="student-survey-menu-button"
            >
                <ChevronLeftIcon />
            </IconButton>
        );
    };

    const MenuButton = () => {
        const CustomAnchor = React.forwardRef(({ ...rest }, ref) => {
            return (
                <IconButton
                    {...rest}
                    ref={ref}
                    tooltipContent="Menu"
                    tooltipPlacement="right"
                    isTooltipADescription
                    data-testid="student-survey-menu-button"
                >
                    <ChevronDownIcon />
                </IconButton>
            );
        });

        return (
            <SelectMenu
                defaultValue={selectedEvaluation === undefined ? "home" : selectedEvaluation[0].transactionId}
                anchor={<CustomAnchor/>}
            >
                <MenuItem value="home" onSelect={() => setSelectedEvaluation(undefined)}>
                    <span className={styles['menu-item-text']}>Home</span>
                    <HomeIcon className={styles['menu-item-home-icon']} />
                </MenuItem>
                {
                    evaluations.map((evaluation) => {
                        const allCompleted = evaluation.every((task) => task.completed);
                        return (
                            <MenuItem value={evaluation[0]?.transactionId} onSelect={() => setSelectedEvaluation(evaluation)}>
                                <span className={styles['menu-item-text']}>
                                    {getCourseLabel(evaluation[0], brandId)}
                                </span>
                                <ColoredStatus
                                    status={allCompleted ? 'Done' : 'Todo'}
                                    translatedStatus={allCompleted ? evaluationPage.evaluationComplete : evaluationPage.evaluationIncomplete}
                                    className={styles['menu-item-status']}
                                />
                            </MenuItem>
                        );
                    })
                }
            </SelectMenu>
        );
    };

    return (
        <div className={styles['evaluation-header']}>
            <BackButton />
            <span className={styles['course-label']}>
                {getCourseLabel(selectedEvaluation[0], brandId)}
            </span>
            <MenuButton />
            <div className={styles['evaluation-header-right']}>
                <StudentInfo hashedStudentId={hashedStudentId} brandId={brandId} />
            </div>
        </div>
    );
};

export default EvaluationExperienceHeader;
